
    

    export default {
        // Matches filter criteria without URL params
        //
        // e.g. inpstartdate|2017|wherecondition|dimsystemsystemname=foo?someParam=foo
        //      matches: inpstartdate|2017|wherecondition|dimsystemsystemname=foo
        //      but not: ?someParam=foo
        // note: walkme permalinks (?walkme=1234) fall into the first bucket
        // Regular Expression:  ([^\|?]+(\|[^\|?]+)*)
        FILTER_PARAMS_REGEX: '([^\\|?]+(\\|[^\\|?]+)*)' // backward slashes need to be escaped (e.g. \\) because it is on a string
    };
